import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '../button/button.component'; // Asumiendo que tienes un ButtonComponent
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-payment-error',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonComponent, TranslateModule],
  templateUrl: './payment-error.component.html',
  styleUrl: './payment-error.component.scss'
})
export class PaymentErrorComponent {
  constructor(private router: Router) {}

  goToHome(): void {
    this.router.navigate(['/']);
  }
}
